var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3505_100051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 3.55566H10.6665V4.44455H6.6665V3.55566Z",
    fill: "#5FC56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 5.3335H10.6665V6.22238H6.6665V5.3335Z",
    fill: "#5FC56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 7.11133H10.6665V8.00022H6.6665V7.11133Z",
    fill: "#5FC56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 8.88867H10.6665V9.77756H6.6665V8.88867Z",
    fill: "#5FC56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 10.6665H10.6665V11.5554H6.6665V10.6665Z",
    fill: "#5FC56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 3.55566H5.77756V4.44455H4.88867V3.55566Z",
    fill: "#5FC56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 5.3335H5.77756V6.22238H4.88867V5.3335Z",
    fill: "#5FC56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 7.11133H5.77756V8.00022H4.88867V7.11133Z",
    fill: "#5FC56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 8.88867H5.77756V9.77756H4.88867V8.88867Z",
    fill: "#5FC56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 10.6665H5.77756V11.5554H4.88867V10.6665Z",
    fill: "#5FC56E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4443 0.888672H3.55539C3.31964 0.888672 3.09355 0.982322 2.92685 1.14902C2.76015 1.31572 2.6665 1.54181 2.6665 1.77756V14.222C2.6665 14.4578 2.76015 14.6838 2.92685 14.8505C3.09355 15.0172 3.31964 15.1109 3.55539 15.1109H12.4443C12.68 15.1109 12.9061 15.0172 13.0728 14.8505C13.2395 14.6838 13.3332 14.4578 13.3332 14.222V1.77756C13.3332 1.54181 13.2395 1.31572 13.0728 1.14902C12.9061 0.982322 12.68 0.888672 12.4443 0.888672ZM12.4443 14.222H3.55539V1.77756H12.4443V14.222Z",
    fill: "#5FC56E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3505_100051"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartNav);
export default __webpack_public_path__ + "static/media/Heart-Nav.717432771e70685e40c811e5e630a86d.svg";
export { ForwardRef as ReactComponent };